import { useState } from 'react'
import { RouterProvider } from 'react-router-dom'

import { authKeys, type AuthState } from '@/api/auth'
import { setLockHandlers, setUnauthorizedHandler } from '@/api/client'
import { createQueryClient } from '@/api/queryClient'
import { ToastProvider } from '@/components/ui'
import { afterUnlock } from '@/lock/afterUnlock'
import { isAppActive } from '@/lock/store'
import { handleLocked } from '@/lock/unlock'
import { OfflineQueryProvider } from '@/offline/OfflineQueryProvider'

import { createAppRouter } from './router'
import { UpdatePrompt } from './UpdatePrompt'

export function App() {
  // Кэш данных сохраняется в IndexedDB (офлайн), очередь тренировки досылается в фоне.
  const [queryClient] = useState(() => {
    const client = createQueryClient()
    // 401 от API: помечаем «не вошёл» — RequireAuth сам уведёт на /login?next=…
    // без перезагрузки страницы (очередь офлайн-мутаций остаётся на месте).
    setUnauthorizedHandler(() => {
      client.setQueryData<AuthState>(authKeys.state, (old) => ({
        setup_required: old?.setup_required ?? false,
        authenticated: false,
      }))
    })
    // 423 от API: сессия заблокирована — LockGate покажет экран разблокировки.
    setLockHandlers({ onLocked: () => handleLocked(() => afterUnlock(client)), isActive: isAppActive })
    return client
  })
  const [router] = useState(createAppRouter)

  return (
    <OfflineQueryProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
        <UpdatePrompt />
      </ToastProvider>
    </OfflineQueryProvider>
  )
}
